import React, {
  useEffect,
  useMemo,
  useRef,
  useState
} from 'react';

import {
  Bot,
  MessageCircle,
  Send,
  ShoppingBag,
  X
} from 'lucide-react';

import {
  Link
} from 'react-router-dom';

import axios from 'axios';

import {
  imgUrl
} from '../data/mockData';


const API =
  process.env.REACT_APP_BACKEND_URL;


const WHATSAPP_URL =
  'https://wa.me/355693520111?text=P%C3%ABrsh%C3%ABndetje%2C%20kam%20nj%C3%AB%20pyetje%20p%C3%ABr%20Lor95%20Boutique.';


const QUICK_QUESTIONS = [
  'Dua veshje sportive',
  'Kam një event',
  'Dua diçka klasike',
  'Produkte me ulje',
  'Si bëhet porosia?'
];


const normalize = text =>
  String(text || '')
    .toLowerCase()
    .normalize('NFD')
    .replace(
      /[\u0300-\u036f]/g,
      ''
    )
    .trim();


const hasSale = product =>
  product.salePrice != null
  &&
  Number(product.salePrice) > 0
  &&
  Number(product.salePrice)
    < Number(product.price);


const effectivePrice = product =>
  hasSale(product)
    ? Number(product.salePrice)
    : Number(product.price);


const detectIntent = question => {

  const q = normalize(question);


  if (
    q.includes('sport')
    ||
    q.includes('palester')
    ||
    q.includes('gym')
    ||
    q.includes('vrap')
    ||
    q.includes('fitness')
    ||
    q.includes('casual sport')
  ) {
    return 'sportive';
  }


  if (
    q.includes('event')
    ||
    q.includes('dasem')
    ||
    q.includes('martese')
    ||
    q.includes('ceremoni')
    ||
    q.includes('darke')
    ||
    q.includes('feste')
    ||
    q.includes('fejese')
    ||
    q.includes('ditelindje')
  ) {
    return 'event';
  }


  if (
    q.includes('klasik')
    ||
    q.includes('elegant')
    ||
    q.includes('zyre')
    ||
    q.includes('formal')
    ||
    q.includes('kostum')
  ) {
    return 'classic';
  }


  if (
    q.includes('ulje')
    ||
    q.includes('oferte')
    ||
    q.includes('zbritje')
    ||
    q.includes('sale')
  ) {
    return 'sale';
  }


  if (
    q.includes('femer')
    ||
    q.includes('femra')
    ||
    q.includes('vajze')
    ||
    q.includes('grua')
  ) {
    return 'women';
  }


  if (
    q.includes('mashkull')
    ||
    q.includes('meshkuj')
    ||
    q.includes('burre')
    ||
    q.includes('djal')
  ) {
    return 'men';
  }


  if (
    q.includes('parfum')
    ||
    q.includes('arome')
  ) {
    return 'perfume';
  }


  return null;
};


const getStaticAnswer =
  question => {

    const q =
      normalize(
        question
      );


    if (
      q.includes('porosi')
      ||
      q.includes('blej')
      ||
      q.includes('porosis')
    ) {
      return {
        text:
          'Zgjidh produktin, ngjyrën dhe masën, shtoje në shportë dhe vazhdo te përfundimi i porosisë. Pagesa bëhet në dorëzim.',
        link:
          '/collections',
        linkText:
          'Shiko koleksionet'
      };
    }


    if (
      q.includes('transport')
      ||
      q.includes('derges')
      ||
      q.includes('dorezim')
    ) {
      return {
        text:
          'Transporti kushton 300 Lek për çdo porosi.'
      };
    }


    if (
      q.includes('adres')
      ||
      q.includes('ndodh')
      ||
      q.includes('dyqan')
      ||
      q.includes('berat')
      ||
      q.includes('vizit')
    ) {
      return {
        text:
          'Lor95 Boutique ndodhet në Rruga Desaret, Berat 5001. Te “Na Vizitoni” mund të shihni hartën dhe udhëzimet.',
        link:
          '/visit',
        linkText:
          'Hap vendndodhjen'
      };
    }


    if (
      q.includes('mase')
      ||
      q.includes('masa')
      ||
      q.includes('numer')
    ) {
      return {
        text:
          'Në faqen e produktit zgjidhni masën. Masat pa stok shfaqen të çaktivizuara dhe nuk mund të selektohen.',
        link:
          '/collections',
        linkText:
          'Shiko produktet'
      };
    }


    if (
      q.includes('ngjyr')
      ||
      q.includes('variant')
    ) {
      return {
        text:
          'Produktet me variante ju lejojnë të zgjidhni ngjyrën dhe masën. Fotot ndryshojnë sipas ngjyrës kur ka foto të veçanta.',
        link:
          '/collections',
        linkText:
          'Shiko produktet'
      };
    }


    if (
      q.includes('orar')
      ||
      q.includes('hapur')
      ||
      q.includes('mbyll')
    ) {
      return {
        text:
          'Lor95 Boutique është hapur çdo ditë dhe mbyllet në orën 21:00.',
        link:
          '/visit',
        linkText:
          'Na vizitoni'
      };
    }


    if (
      q.includes('pages')
      ||
      q.includes('cash')
    ) {
      return {
        text:
          'Pagesa bëhet në dorëzim. Ju paguani kur merrni porosinë.'
      };
    }


    if (
      q.includes('whatsapp')
      ||
      q.includes('what')
    ) {
      return {
        text:
          'Mund të na shkruani direkt në WhatsApp.',
        whatsapp:
          true
      };
    }


    return null;
  };


const recommendationForIntent =
  (
    intent,
    products
  ) => {

    const inStock =
      products.filter(
        product =>
          Number(
            product.stock
            ??
            0
          ) > 0
      );


    let matches = [];
    let text = '';
    let collectionLink =
      '/collections';


    if (
      intent === 'sportive'
    ) {
      matches =
        inStock.filter(
          product => {
            const category =
              normalize(
                product.category
              );

            return (
              category ===
                normalize('Sportive')
              ||
              category ===
                normalize('Këpucë')
              ||
              category ===
                normalize('Bluza')
            );
          }
        );

      text =
        'Për një look sportiv do t’ju sugjeroja veshje nga kategoria Sportive, bluza komode dhe atlete. Këto janë disa zgjedhje që kemi aktualisht:';

      collectionLink =
        '/collections?category=Sportive';
    }


    if (
      intent === 'event'
    ) {
      const eventCategories = [
        'Fustane',
        'Këmisha',
        'Xhaketa',
        'Pantallona të Gjata',
        'Këpucë'
      ].map(
        normalize
      );

      matches =
        inStock.filter(
          product =>
            eventCategories.includes(
              normalize(
                product.category
              )
            )
        );

      text =
        'Për event do të zgjidhja diçka më elegante: fustan ose kombinim këmishë/xhaketë me pantallona klasike dhe këpucë. Ja disa produkte që mund t’ju përshtaten:';

      collectionLink =
        '/collections';
    }


    if (
      intent === 'classic'
    ) {
      const classicCategories = [
        'Këmisha',
        'Xhaketa',
        'Pantallona të Gjata',
        'Fustane',
        'Këpucë'
      ].map(
        normalize
      );

      matches =
        inStock.filter(
          product =>
            classicCategories.includes(
              normalize(
                product.category
              )
            )
        );

      text =
        'Për një stil klasik dhe elegant, këto do të ishin zgjedhje të mira:';

      collectionLink =
        '/collections';
    }


    if (
      intent === 'sale'
    ) {
      matches =
        inStock.filter(
          hasSale
        );

      text =
        'Këto janë disa nga produktet tona aktualisht me ulje:';

      collectionLink =
        '/collections?category=Produkte%20me%20Ulje';
    }


    if (
      intent === 'women'
    ) {
      matches =
        inStock.filter(
          product =>
            normalize(
              product.gender
            )
            === normalize(
              'Femra'
            )
        );

      text =
        'Ja disa sugjerime nga koleksioni për femra:';

      collectionLink =
        '/collections?gender=Femra';
    }


    if (
      intent === 'men'
    ) {
      matches =
        inStock.filter(
          product =>
            normalize(
              product.gender
            )
            === normalize(
              'Meshkuj'
            )
        );

      text =
        'Ja disa sugjerime nga koleksioni për meshkuj:';

      collectionLink =
        '/collections?gender=Meshkuj';
    }


    if (
      intent === 'perfume'
    ) {
      matches =
        inStock.filter(
          product =>
            normalize(
              product.category
            )
            === normalize(
              'Parfume'
            )
        );

      text =
        'Nëse po kërkoni parfum, këto janë disa nga aromat që kemi aktualisht:';

      collectionLink =
        '/collections?category=Parfume';
    }


    matches =
      matches
        .sort(
          (
            a,
            b
          ) => {

            if (
              hasSale(a)
              &&
              !hasSale(b)
            ) {
              return -1;
            }

            if (
              !hasSale(a)
              &&
              hasSale(b)
            ) {
              return 1;
            }

            return 0;
          }
        )
        .slice(
          0,
          3
        );


    return {
      text,
      products:
        matches,
      link:
        collectionLink,
      linkText:
        'Shiko të gjitha'
    };
  };


export default function CustomerChatbot() {

  const [
    open,
    setOpen
  ] =
    useState(false);

  const [
    input,
    setInput
  ] =
    useState('');

  const [
    products,
    setProducts
  ] =
    useState([]);

  const [
    messages,
    setMessages
  ] =
    useState([
      {
        id: 1,
        from: 'bot',
        text:
          'Përshëndetje! 👋 Jam asistenti i Lor95 Boutique. Më tregoni çfarë po kërkoni dhe mund t’ju sugjeroj produkte nga koleksioni ynë.'
      }
    ]);


  const bottomRef =
    useRef(null);


  useEffect(
    () => {

      axios
        .get(
          `${API}/api/products`
        )
        .then(
          response => {

            setProducts(
              Array.isArray(
                response.data
              )
                ? response.data
                : []
            );
          }
        )
        .catch(
          () => {

            setProducts([]);
          }
        );

    },
    []
  );


  useEffect(
    () => {

      if (open) {

        bottomRef
          .current
          ?.scrollIntoView({
            behavior:
              'smooth'
          });
      }

    },
    [
      messages,
      open
    ]
  );


  const ask =
    question => {

      const clean =
        question.trim();


      if (!clean) {
        return;
      }


      const intent =
        detectIntent(
          clean
        );


      let answer;


      if (
        intent
        &&
        products.length > 0
      ) {

        answer =
          recommendationForIntent(
            intent,
            products
          );


        if (
          answer.products
            .length === 0
        ) {

          answer = {
            text:
              'Nuk po gjej një produkt të përshtatshëm në stok për momentin. Mund të shihni koleksionin ose të na shkruani në WhatsApp.',
            link:
              answer.link,
            linkText:
              'Shiko koleksionin',
            whatsapp:
              true
          };
        }

      } else {

        answer =
          getStaticAnswer(
            clean
          )
          ||
          {
            text:
              'Më tregoni pak më shumë çfarë kërkoni — për shembull “dua veshje sportive”, “kam një event”, “dua diçka klasike” ose “dua produkte me ulje”.',
            whatsapp:
              true
          };
      }


      setMessages(
        current => [
          ...current,
          {
            id:
              Date.now(),
            from:
              'user',
            text:
              clean
          },
          {
            id:
              Date.now()
              +
              1,
            from:
              'bot',
            ...answer
          }
        ]
      );


      setInput('');
    };


  const submit =
    event => {

      event.preventDefault();

      ask(
        input
      );
    };


  return (
    <>

      <button
        type="button"

        onClick={
          () =>
            setOpen(
              value =>
                !value
            )
        }

        className="fixed z-[70] right-5 bottom-5 sm:right-7 sm:bottom-7 w-14 h-14 rounded-full bg-[#c8953d] text-white shadow-[0_12px_35px_rgba(0,0,0,0.28)] flex items-center justify-center hover:scale-105 transition-transform"

        aria-label={
          open
            ? 'Mbyll asistentin'
            : 'Hap asistentin'
        }
      >

        {
          open
            ? (
              <X className="h-6 w-6" />
            )
            : (
              <MessageCircle className="h-6 w-6" />
            )
        }

      </button>


      {open && (

        <div className="fixed z-[69] right-4 bottom-24 sm:right-7 sm:bottom-24 w-[calc(100%-2rem)] sm:w-[400px] max-h-[650px] bg-white rounded-2xl shadow-[0_20px_60px_rgba(0,0,0,0.32)] overflow-hidden border border-gray-200 flex flex-col">

          <div className="bg-[#11110f] text-white px-5 py-4 flex items-center gap-3">

            <div className="w-10 h-10 rounded-full bg-[#c8953d] flex items-center justify-center">

              <Bot className="h-5 w-5" />

            </div>


            <div>

              <p className="font-semibold">
                Lor95 Assistant
              </p>

              <p className="text-xs text-white/60">
                Sugjerime sipas koleksionit aktual
              </p>

            </div>

          </div>


          <div className="flex-1 overflow-y-auto p-4 bg-[#f8f5f0] space-y-3">

            {messages.map(
              message => (

                <div
                  key={
                    message.id
                  }

                  className={`flex ${
                    message.from
                    ===
                    'user'
                      ? 'justify-end'
                      : 'justify-start'
                  }`}
                >

                  <div
                    className={`max-w-[88%] rounded-2xl px-4 py-3 text-sm leading-relaxed ${
                      message.from
                      ===
                      'user'
                        ? 'bg-[#11110f] text-white rounded-br-sm'
                        : 'bg-white text-gray-700 border border-gray-200 rounded-bl-sm'
                    }`}
                  >

                    <p>
                      {
                        message.text
                      }
                    </p>


                    {message.products?.length > 0 && (

                      <div className="mt-3 space-y-2">

                        {message.products.map(
                          product => (

                            <Link
                              key={
                                product.id
                              }

                              to={
                                `/product/${product.id}`
                              }

                              onClick={
                                () =>
                                  setOpen(
                                    false
                                  )
                              }

                              className="flex gap-3 p-2 bg-[#f8f5f0] border border-[#eadfce] hover:border-[#c8953d] transition-colors"
                            >

                              <img
                                src={
                                  imgUrl(
                                    product.image
                                    ||
                                    product.images?.[0]?.url
                                  )
                                }

                                alt={
                                  product.name
                                }

                                loading="lazy"

                                className="w-14 h-16 object-cover bg-gray-100 flex-shrink-0"
                              />


                              <div className="min-w-0 flex-1">

                                <p className="font-semibold text-gray-900 line-clamp-1">
                                  {
                                    product.name
                                  }
                                </p>

                                <p className="text-[11px] text-gray-500">
                                  {
                                    product.category
                                  }
                                </p>


                                {hasSale(product) ? (

                                  <div className="flex items-baseline gap-2 mt-1">

                                    <span className="text-[11px] line-through text-gray-400">
                                      {
                                        Math.round(
                                          Number(
                                            product.price
                                          )
                                          /
                                          100
                                        )
                                      }
                                      {' '}
                                      Lek
                                    </span>

                                    <span className="text-xs font-bold text-red-600">
                                      {
                                        Math.round(
                                          effectivePrice(
                                            product
                                          )
                                          /
                                          100
                                        )
                                      }
                                      {' '}
                                      Lek
                                    </span>

                                  </div>

                                ) : (

                                  <p className="text-xs font-bold text-gray-900 mt-1">

                                    {
                                      Math.round(
                                        effectivePrice(
                                          product
                                        )
                                        /
                                        100
                                      )
                                    }
                                    {' '}
                                    Lek

                                  </p>

                                )}

                              </div>

                            </Link>
                          )
                        )}

                      </div>

                    )}


                    {message.link && (

                      <Link
                        to={
                          message.link
                        }

                        onClick={
                          () =>
                            setOpen(
                              false
                            )
                        }

                        className="inline-flex items-center gap-1 mt-3 text-[#a77426] font-semibold"
                      >

                        {
                          message.linkText
                        }

                        <ShoppingBag className="h-4 w-4" />

                      </Link>

                    )}


                    {message.whatsapp && (

                      <a
                        href={
                          WHATSAPP_URL
                        }

                        target="_blank"

                        rel="noopener noreferrer"

                        className="inline-flex items-center gap-2 mt-3 ml-3 text-[#148b46] font-semibold"
                      >

                        <MessageCircle className="h-4 w-4" />

                        WhatsApp

                      </a>

                    )}

                  </div>

                </div>
              )
            )}

            <div
              ref={
                bottomRef
              }
            />

          </div>


          <div className="px-4 py-3 border-t border-gray-200 bg-white">

            <div className="flex gap-2 overflow-x-auto pb-2 mb-2">

              {QUICK_QUESTIONS.map(
                question => (

                  <button
                    key={
                      question
                    }

                    type="button"

                    onClick={
                      () =>
                        ask(
                          question
                        )
                    }

                    className="flex-shrink-0 px-3 py-2 rounded-full border border-[#d7c5a5] bg-[#fbf7f1] text-[11px] text-gray-700 hover:border-[#c8953d]"
                  >

                    {
                      question
                    }

                  </button>
                )
              )}

            </div>


            <form
              onSubmit={
                submit
              }

              className="flex items-center gap-2"
            >

              <input
                value={
                  input
                }

                onChange={
                  event =>
                    setInput(
                      event.target.value
                    )
                }

                placeholder="P.sh. Kam një event, çfarë më sugjeron?"

                className="flex-1 h-11 rounded-full border border-gray-300 px-4 text-sm outline-none focus:border-[#c8953d]"
              />


              <button
                type="submit"

                className="w-11 h-11 rounded-full bg-[#11110f] text-white flex items-center justify-center hover:bg-[#c8953d] transition"

                aria-label="Dërgo"
              >

                <Send className="h-4 w-4" />

              </button>

            </form>

          </div>

        </div>
      )}

    </>
  );
}
